import { createSelector } from 'reselect';
import type { RootState } from 'store';

export const selectResourceDirectoryRules = (state: RootState) => state.resource.directoryRules;
export const selectResourceDirectoryRule = (key: string) => createSelector([selectResourceDirectoryRules], (directoryRules) => directoryRules?.[key]);
